import { render, staticRenderFns } from "./AddFeesDelivery.vue?vue&type=template&id=d32d00fc"
import script from "./AddFeesDelivery.vue?vue&type=script&lang=js"
export * from "./AddFeesDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports